import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const FloatingBarChart = ({ dataArray, tooltipType = 'normal' }) => {

const labels = dataArray.map(item => item.duration);
const averageDailyBalanceData = dataArray.map(item => parseFloat(item.averageDailyBalance));
  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Monthly avg balance',
        data: averageDailyBalanceData,
        backgroundColor: 'rgba(88, 80, 236, 1)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 0,
        barThickness: 8, 
        maxBarThickness: 10,
        borderRadius: 20,
      },
    ],
  };

  // Define chart options
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: false,
        text: 'Monthly avg balance (₹)',
      },

      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw || 0;
            if (tooltipType === 'currency') {
              return `₹: ${value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`; // Format in INR
            } else if(tooltipType === 'percent'){
              return `${value}%`;
            }
          },
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: {
            display: false, 
        },

        ticks: {
            autoSkip: false,
            maxRotation: 30,
            minRotation: 30, 
        }
      },
      y: {
        title: {
          display: false,
          text: 'Temperature (°C)',
        },
        grid: {
            display: true, 
            drawBorder: true, 
            borderDash: [10, 10],
        },
        ticks: {
            suggestedMin: Math.min(...averageDailyBalanceData) - 50000, // Slightly below min value
            suggestedMax: Math.max(...averageDailyBalanceData) + 50000, // Slightly above max value
            stepSize: (Math.max(...averageDailyBalanceData) - Math.min(...averageDailyBalanceData)) / 8, // Divide range by 8 for 8 lines
        },
      },
    },
  };

  return (
    <div>
      <Bar data={data} options={options} />
    </div>
  );
};

export default FloatingBarChart;
